module.exports = __webpack_public_path__ + "img/icon.084bb7cb.png";